import template from './payment-codes-list.html';
import tripEvents from '../../../config/events.constant';

const DIRECTIVE_NAME = PaymentCodesList.DIRECTIVE_NAME = 'ktPaymentCodesList';
export default function PaymentCodesList() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: PaymentCodesListController,
        controllerAs: '$ctrl',
        scope: {
            paymentCodes: `=${DIRECTIVE_NAME}`,
            model: `=${DIRECTIVE_NAME}Model`,
            errorMessage: `=${DIRECTIVE_NAME}ErrorMessage`,
            isAutocompleteEnable: `=${DIRECTIVE_NAME}IsAutocompleteEnable`,
            tripId: `=${DIRECTIVE_NAME}TripId`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function PaymentCodesListController(
    $scope,
    $rootScope,
    $timeout,
    paymentCodesListService,
) {
    'ngInject';

    const vm = this;

    vm.paymentFormValid = false;

    Object.assign(vm, {
        $onInit,
        initScope,
        updateInput,
        isHierarchicalPaymentCode: paymentCodesListService.isHierarchicalPaymentCode,
        getPaymentCodes: paymentCodesListService.getPaymentCodes,
        regexChecker: paymentCodesListService.regexChecker,
        isFreeTextCodeVisible: paymentCodesListService.isFreeTextCodeVisible,
        isMaskedInputCodeVisible: paymentCodesListService.isMaskedInputCodeVisible,
        isPredefinedDropdownCodeVisible: paymentCodesListService.isPredefinedDropdownCodeVisible,
        isFixedValueCodeVisible: paymentCodesListService.isFixedValueCodeVisible,
        isMaskDropdownCodeVisible: paymentCodesListService.isMaskDropdownCodeVisible,
        isDropdownMaskCodeVisible: paymentCodesListService.isDropdownMaskCodeVisible,
        hasParentPaymentCode: paymentCodesListService.hasParentPaymentCode,
    });

    function $onInit() {
        initScope($scope);
        subscribe();
    }

    function subscribe() {
        $timeout(() => $scope.$watch(function(scope) {
            vm.paymentCodeForm = angular.isDefined(scope.paymentCodesForm) ? scope.paymentCodesForm.$valid : false;
            return vm.paymentCodeForm;
        }, updateInput, true));
    }

    function initScope(scope) {
        scope.onSelection = function($item, $model, $label, $id) {
            if ($rootScope.approversPaymentCodeId === $id) {
                $rootScope.$broadcast(tripEvents.CLEAR_APPROVER, {item: {value: $label}, dropdownId: $id});
            }
        };
    }

    function updateInput(newValue, oldValue) {
        if (newValue !== oldValue) {
            if (newValue !== oldValue && angular.isDefined($rootScope.approvers)) {
                if (!newValue) {
                    $rootScope.$broadcast(tripEvents.WIPE_APPROVER);
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/payment-codes-list-component.js